export default "__VITE_ASSET__BrnbDken__"